import request from "../plugins/axios";

// 营销台统计数据
export function getMarketing(params) {
    return request({
        url: '/Index/Marketing',
        method: 'get',
        params: params
    })
}